<!--
 * @Description: 我的订单 - 已结算
 * @Date: 2019-09-02 09:48:51
 -->

<!--用户管理-->
<template>
  <div class="table-box">
    <!--查询-->
    <div class="search-box">
      <div class="search-left">
        <div>
          <span>订单结算月度:</span>
          <el-date-picker
            @change="dateChange"
            range-separator="-"
            value-format="yyyy-MM"
            type="month"
            v-model="searchQuery.orderMonth"
          ></el-date-picker>
        </div>
        <div>
          <span>供应商：</span>
          <el-input
            v-model="searchQuery.supplierName"
            placeholder="请输入供应商名称"
            style="width:200px;"
          ></el-input>
        </div>
        <div>
          <span>订单编号：</span>
          <el-input
            placeholder="请输入订单编号"
            style="width:150px;"
            v-model="searchQuery.orderNo"
            clearable
          ></el-input>
        </div>
        <div>
          <span>支付状态:</span>
          <el-select
            v-model="searchQuery.payStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="(item, index) in payList"
              :key="index"
              :label="item.label"
              :value="item.key"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="search-right">
        <el-button type="primary" @click="searchEvent">查询</el-button>
      </div>
    </div>
    <!--列表-->
    <div class="">
      <el-table
        v-loading="loading"
        :data="tableData"
        border=""
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="false"
      >
        <el-table-column
          prop="orderNo"
          label="订单编号"
          align="center"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="orderMonth"
          label="结算月度"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="supplieName"
          label="供应商"
        >
          <template slot-scope="{ row }">
            <div style="display:flex;justify-content:center;">
              <div
                style="max-width:90%;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;margin-right:8px;"
              >
                {{ row.supplierName }}
              </div>
              <el-popover placement="top-start" trigger="hover">
                <el-table :data="row.rateList">
                  <el-table-column
                    width="200"
                    property="date"
                    label="服务费发放区间（自然人）"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.startPrice | moneyFixed }}—{{
                        +scope.row.endPrice | moneyFixed
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="100"
                    property="name"
                    label="服务费率（%）"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.sumScale | transScale }}
                    </template>
                  </el-table-column>
                </el-table>
                <img
                  src="http://cdn.yxvzb.com/WEB/SaaS/images/info.png"
                  slot="reference"
                  class="info"
                />
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="综合服务费"
        >
          <template slot-scope="{ row }">
            <div
              style="display:flex;justify-content:space-around;align-items:center;"
            >
              <span>{{ row.initOrderPrice | moneyFixed }}</span>
              <el-button
                type="text"
                @click="showComponent('zongheDetail', row)"
              >
                详情
              </el-button>
              <el-popover
                placement="top-start"
                trigger="hover"
                v-if="row.discountPrice"
              >
                <div>应付：{{ row.initOrderPrice | moneyFixed }}</div>
                <div>优惠：{{ row.discountPrice | moneyFixed }}</div>
                <div>实付：{{ row.orderPrice | moneyFixed }}</div>
                <img
                  src="http://cdn.yxvzb.com/WEB/SaaS/images/coupon.svg"
                  slot="reference"
                  class="info"
                />
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="支付状态"
          width="180"
        >
          <template slot-scope="scope">
            <div
              style="display:flex;justify-content:space-around;align-items:center;"
            >
              <span>{{ finishFil(scope.row.payStatus) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="支付成功时间"
          width="180"
        >
          <template slot-scope="scope">
            <div
              style="display:flex;justify-content:space-around;align-items:center;"
            >
              <span>{{ scope.row.finishPayDt | transDate }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="showComponent('confirmPay', scope.row)"
              :disabled="scope.row.payStatus == 1"
            >
              {{ zonghePay(scope.row.payStatus) }}
            </el-button>
            <el-button
              type="text"
              :disabled="scope.row.payStatus != 2"
              @click="downloadFile(scope.row)"
            >
              下载回单
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>
    </div>
    <component
      :is="componentName"
      :show-dialog="showDetail"
      :activeTask="activeTask"
    ></component>
  </div>
</template>
<script>
import confirmPay from './zongheConfirmPay.vue';
import zongheDetail from './zongheDetail.vue';
import { comprehensive } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { makeSure } from '@/Mixin/makeSure';
import datePicker from '@/Mixin/datePicker';
export default {
  mixins: [pageInation, makeSure, datePicker],
  data() {
    return {
      ruleForm: {
        taskDate: ''
      }, // 用户信息
      getList: comprehensive.comprehensiveOrderList, // 获取列表的AJAX
      searchQuery: {
        taskDate: '',
        payStatus: '',
        orderNo: ''
      },
      showDetail: false,
      componentName: '',
      activeTask: 'projectPay',
      item: {
        data: null
      },
      payList: [
        { label: '待支付', key: 0 },
        { label: '支付中', key: 1 },
        { label: '支付成功', key: 2 },
        { label: '支付失败', key: 3 }
      ]
    };
  },
  components: {
    confirmPay,
    zongheDetail
  },
  provide() {
    return {
      itemData: this.item
    };
  },
  computed: {},
  methods: {
    finishFil(v) {
      if (v == 0) {
        return '待支付';
      } else if (v == 1) {
        return '支付中';
      } else if (v == 2) {
        return '支付成功';
      } else if (v == 3) {
        return '支付失败';
      }
    },
    zonghePay(v) {
      if (v == 2) {
        return '详情';
      } else if (v == 3) {
        return '重新支付';
      } else {
        return '支付';
      }
    },
    showComponent(componentName, item = null) {
      this.item.data = item;
      this.componentName = componentName;
      this.showDetail = true;
    },
    downloadFile(row) {
      window.open(
        `${comprehensive.downloadComprehensiveReceipt}?comprehensiveOrderId=${row.id}`
      );
    }
  },
  created() {
    if (this.$route.query.orderNo) {
      this.searchQuery.orderNo = this.$route.query.orderNo;
      this.searchQuery.orderMonth = '';
    }
  }
};
</script>
<style lang="scss" scoped>
.info {
  width: 14px;
  height: 14px;
  margin-top: -4px;
}
</style>
